/* ============================================================
   okioset
   ============================================================ */

export const okioset = {
    id: "8",
    type: "playlist",
    featured: true,
    title: "Open Mixer",
    link: "open-mixer",
    playlistBg: "rgba(255, 35, 35, 1)",
    imgUrl: "../image/set/open-mixer/alibhtty.jpg",  //  /image/set/open-mixer/cover.jpg
    hoverColor: "rgba(255, 35, 35, 1)",
    artist: "alibhtty",
    artistImgUrl: "../image/djs/alibhtty/alibhtty.jpg",
    artistBio: "open-mixer",
    artistDownload: "Descargar",
    bannerUno: "",
    downloadData: [],
    playlistImages: [
      "../image/set/open-mixer/album/1.jpg",
      "../image/set/open-mixer/album/2.jpg",
      "../image/set/open-mixer/album/3.jpg",
      "../image/set/open-mixer/album/4.jpg",
      "../image/set/open-mixer/album/5.jpg",
      "../image/set/open-mixer/album/6.jpg",
      "../image/set/open-mixer/album/7.jpg"
    ],
    playlistData: [
      {
        id: "1",
        songName: "Ali Bhtty OKIO BAR - Open Mixer",
        songimg: "../image/set/open-mixer/alibhtty.jpg",
        songArtist: "Ali Bhtty",
        artistLink: "alibhtty",
        link: "https://dl.dropbox.com/scl/fi/rvh65g8clijtpum7vqbxu/alibhtty-Open-Mixer-OKIO-BAR.mp3?rlkey=2jcs0u3f0sa1hl11i5h1t754h&dl=1",
        trackTime: "19:20"
      }
    ]
  }
